export const TOPSPANDER_ALL_CABANG_GET_REQUEST =
  "TOPSPANDER_ALL_CABANG_GET_REQUEST";
export const TOPSPANDER_ALL_CABANG_GET_SUCCESS =
  "TOPSPANDER_ALL_CABANG_GET_SUCCESS";
export const TOPSPANDER_ALL_CABANG_GET_FAIL = "TOPSPANDER_ALL_CABANG_GET_FAIL";
export const TOPSPANDER_ALL_CABANG_GET_RESET =
  "TOPSPANDER_ALL_CABANG_GET_RESET";
